<style lang="sass">
.mgm-share-box {
    background: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 240px;
    z-index: 1;

    .mgm-share-item {
        height: 56px;
        width: 56px;

        &>img {
            width: 100%;
            height: 100%;
        }
    }

    .mgm-share-box-title {
        height: 40px;
        text-align: center;
        line-height: 40px;
    }

    .mgm-share-box-tools,
    .mgm-share-box-targets {
        padding-left: 10px;
        height: 100px;
        font-size: 12px;
        display: flex;
        align-items: center;
    }
}
</style>

<template>
    <w-mask :is-show="isShow" @click="hide">
        <transition name="bottom">
            <div v-show="isShow" class="mgm-share-box">
                <div class="mgm-share-box-title">
                    立即邀请好友
                </div>

                <div class="wui-border-1px wui-border-b mgm-share-box-tools">
                    <w-row>
                        <w-cell width="72" @click="openQr">
                            <w-col>
                                <w-cell align="center">
                                    <div class="mgm-share-item">
                                        <img src="../../assets/imgs/share-qr@2x.png" alt="">
                                    </div>
                                </w-cell>
                                <w-cell align="center">
                                    当面扫码
                                </w-cell>
                            </w-col>

                        </w-cell>
                        <w-cell width="72">
                            <w-col class="w-clipboard-data-text" :data-clipboard-text="options.url">
                                <w-cell align="center">
                                    <div class="mgm-share-item">
                                        <img src="../../assets/imgs/share-link@2x.png" alt="">
                                    </div>
                                </w-cell>
                                <w-cell align="center">
                                    复制链接
                                </w-cell>
                            </w-col>
                        </w-cell>
                    </w-row>
                </div>

                <div class="mgm-share-box-targets">
                    <w-row>
                        <w-cell width="72" @click.native="shareTo('0')">
                            <w-col>
                                <w-cell align="center">
                                    <div class="mgm-share-item">
                                        <img src="../../assets/imgs/share-wechat@2x.png" alt="">
                                    </div>
                                </w-cell>
                                <w-cell align="center">
                                    微信好友
                                </w-cell>
                            </w-col>

                        </w-cell>
                        <w-cell width="72" @click.native="shareTo('1')">
                            <w-col>
                                <w-cell align="center">
                                    <div class="mgm-share-item">
                                        <img src="../../assets/imgs/share-wechat-area@2x.png" alt="">
                                    </div>
                                </w-cell>
                                <w-cell align="center">
                                    朋友圈
                                </w-cell>
                            </w-col>
                        </w-cell>
                        <w-cell width="72" @click.native="shareTo('2')">
                            <w-col>
                                <w-cell align="center">
                                    <div class="mgm-share-item">
                                        <img src="../../assets/imgs/share-qq@2x.png" alt="">
                                    </div>
                                </w-cell>
                                <w-cell align="center">
                                    QQ
                                </w-cell>
                            </w-col>
                        </w-cell>

                        <w-cell width="72" @click.native="shareTo('3')">
                            <w-col>
                                <w-cell align="center">
                                    <div class="mgm-share-item">
                                        <img src="../../assets/imgs/share-qzone@2x.png" alt="">
                                    </div>
                                </w-cell>
                                <w-cell align="center">
                                    QQ空间
                                </w-cell>
                            </w-col>
                        </w-cell>
                    </w-row>
                </div>
            </div>
        </transition>
    </w-mask>
</template>


<script>
    import { openShare } from '../libs/native';
    import Clipboard from 'clipboard';

    export default {
        name: 'b-share',
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            opts: {
                type: Object,
                default: () => {
                    return {
                        url: '',
                        desc: '',
                        title: '',
                        thumbImage: ''
                    }
                }
            }
        },
        data() {
            return {
                visiable: this.isShow,
                options: this.opts
            }
        },
        watch: {
            isShow(val) {
                this.visiable = val;
            },
            opts(val) {
                this.options = val
            }
        },
        methods: {
            openQr() {
                this.$emit('open-qrimg');
            },
            shareTo(t) {
                var opts = { ...this.options, type: t };
                openShare.apply(this, [opts])
            },
            show() {
                this.visiable = true;
                this.$emit('open', this)
            },
            hide() {
                this.visiable = false;
                this.$emit('close', this)
            }
        },
        mounted() {
            var clipboard = new Clipboard('.w-clipboard-data-text');
            clipboard.on('success', () => {
                this.$wui.Toast.show({
                    content: '复制成功',
                    pos: 'middle'
                })
            });
        }
    }
</script>



// WEBPACK FOOTER //
// share.vue?278bc301